import type { ComponentType } from 'react';
import { logInfo } from '~/utilities/loggers';

type ImportedComponent<Props> = { default: ComponentType<Props> };

const retryDelayMilliseconds = 500;

function RenderNothing() {
  return null;
}

// App Router's next/dynamic throws on a failed import, which replaces the whole page with error.tsx.
export default async function importWithFallback<Props>(
  load: () => Promise<ImportedComponent<Props>>,
  name: string
): Promise<ImportedComponent<Props>> {
  try {
    return await load();
  } catch {
    await new Promise(resolve => setTimeout(resolve, retryDelayMilliseconds));
  }

  try {
    return await load();
  } catch (error) {
    logInfo('Dynamic import failed', {
      error: error instanceof Error ? error.message : String(error),
      name
    });

    return { default: RenderNothing };
  }
}
